import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-mastercard",
  templateUrl: "./mastercard.component.html",
  styleUrls: ["./mastercard.component.scss"],
})
export class MastercardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
